import { SYNTHETIC_ROOT_ID } from "../useHealthModule";
export const CLUSTER_HEALTH_ALERT_TARGET = "__root__";
const toHealthAlertTarget = (nodeId) => nodeId === SYNTHETIC_ROOT_ID ? CLUSTER_HEALTH_ALERT_TARGET : nodeId;
export default toHealthAlertTarget;
